import ExistingTagsItemBase from './existingTagsItemBase';

export interface IExistingTagsAddButtonProps {
	value: string | number;
	onClick?: (value?: string) => void;
}

const ExistingTagsAddButton: React.FunctionComponent<IExistingTagsAddButtonProps> = props => {
	return (
		<div hidden={!props.value} data-test-id="available-tags-add-btn-container">
			<ExistingTagsItemBase>
				<button
					className="rup-btn rup-btn--text"
					type="button"
					data-test-id="available-tags-add-btn"
					onClick={() => {
						if (props.onClick) {
							props.onClick(typeof props.value === 'string' ? props.value : undefined);
						}
					}}
				>
					{typeof props.value === 'number'
						? `+ ${localize('Add')} [${props.value}] ${localize('tags')}`
						: `+ ${localize('Add')} "${props.value}" ${localize('as a tag')}`}
				</button>
			</ExistingTagsItemBase>
		</div>
	);
};

export default ExistingTagsAddButton;
